import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564bb2c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "time-select-button" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "range-picker" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-rili" })
], -1))
const _hoisted_8 = { class: "grid-detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "热点网格总数", -1))
const _hoisted_10 = { class: "count" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "个", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "已核查热点网格数", -1))
const _hoisted_13 = { class: "count" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "个", -1))
const _hoisted_15 = { class: "grid-list" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "逐时列表", -1))
const _hoisted_18 = { class: "grid-statistic" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "分布统计", -1))
const _hoisted_20 = { class: "pie" }
const _hoisted_21 = { class: "bg" }
const _hoisted_22 = { id: "pie-chart" }
const _hoisted_23 = { class: "no-data" }
const _hoisted_24 = { class: "grid-trend" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "数量趋势图", -1))
const _hoisted_26 = { class: "trend-header" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "个", -1))
const _hoisted_28 = { class: "trend-content" }
const _hoisted_29 = { id: "line-chart" }
const _hoisted_30 = { class: "no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_RangePicker = _resolveComponent("RangePicker")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["leftContainer", _ctx.dialogHide ? 'hide' : 'show'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Select, {
          value: _ctx.productType,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productType) = $event)),
          align: 'left',
          onChange: _ctx.changeType
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridOption?.buttonChildren, (item) => {
              return (_openBlock(), _createBlock(_component_Option, {
                key: item.key,
                value: item.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name) + "热点网格 ", 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "onChange"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeType, (i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['btn', _ctx.formData.timeType === i.key ? 'active' : '']),
              onClick: ($event: any) => (_ctx.handleSelect(i.key)),
              key: i.key
            }, _toDisplayString(i.label), 11, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", { class: "time-content" }, " 当前统计维度：" + _toDisplayString(_ctx.currentTime), 513), [
          [_vShow, _ctx.formData.timeType !== 'custom']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            style: _normalizeStyle(_ctx.formData.timeType !== 'custom'? 'color: #ccc' : '')
          }, "自定义时间段:", 4),
          _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
            default: _withCtx(() => [
              _createVNode(_component_RangePicker, {
                value: _ctx.rangData,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rangData) = $event)),
                format: "YYYY-MM-DD HH:00",
                showTime: "",
                "allow-clear": false,
                disabled: _ctx.formData.timeType !== 'custom',
                disabledDate: _ctx.disabledDate,
                onOk: _ctx.onTimeChange,
                onOpenChange: _ctx.openStartChange
              }, {
                suffixIcon: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["value", "disabled", "disabledDate", "onOk", "onOpenChange"])
            ]),
            _: 1
          }, 8, ["locale"])
        ], 512), [
          [_vShow, _ctx.formData.timeType === 'custom']
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_8, [
      _createElementVNode("li", null, [
        _hoisted_9,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.gridDetailData.gridCount ?? 0), 1),
          _hoisted_11
        ])
      ]),
      _createElementVNode("li", null, [
        _hoisted_12,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.gridDetailData.examineGridCount ?? 0), 1),
          _hoisted_14
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", {
          class: "export",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportList && _ctx.exportList(...args)))
        }, "导出")
      ]),
      _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
        default: _withCtx(() => [
          _createVNode(_component_Table, {
            columns: _ctx.columns,
            "data-source": _ctx.tableData,
            rowKey: "key",
            customRow: _ctx.customRow,
            "row-selection": _ctx.rowSelection,
            pagination: {
            total: _ctx.pageData.total,
            pageSize: 3,
            size: 'small',
            current: _ctx.pageData.current,
            showQuickJumper: false,
            showTotal: (total) => `共 ${total} 条`,
            onChange: (page, pageSize) => _ctx.handleTableChange(page, pageSize),
          }
          }, {
            time: _withCtx(({ text,}) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.moment(text, 'YYYYMMDDHH').format('YYYY-MM-DD HH:00')), 1)
            ]),
            _: 1
          }, 8, ["columns", "data-source", "customRow", "row-selection", "pagination"])
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("div", _hoisted_21, null, 512), [
          [_vShow, _ctx.pieChartShow]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [
          [_vShow, _ctx.pieChartShow]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_23, null, 512), [
          [_vShow, !_ctx.pieChartShow]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.productType === 'pm2_5' ? 'PM₂.₅热点网格':'PM₁₀热点网格'), 1)
      ], 512), [
        [_vShow, _ctx.lineChartShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_29, null, 512), [
        [_vShow, _ctx.lineChartShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [
        [_vShow, !_ctx.lineChartShow]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["iconfont hide-icon", _ctx.dialogHide ? 'icon-shouqijiantouxiao-copy-copy' : 'icon-shouqijiantouxiao-copy']),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
    }, null, 2)
  ], 2))
}